/**
 * MONEY-MINOR-REBUILD A7 — stale-client guard.
 *
 * This build expects all cost/money values from the API to be in MINOR units.
 * The API advertises its contract via the `X-Cost-Units` response header (and a
 * `costUnits` field on /health). If the server ever reports a DIFFERENT contract
 * than this client expects — e.g. a rolled-back API still emitting major units,
 * or this client left open in a tab across a cutover — showing money would be
 * 100× wrong. We detect the mismatch and block the UI, forcing a reload.
 *
 * We do NOT block when the header is absent: an older API that predates this
 * header can't be asserted either way, and blocking on absence would break
 * against any endpoint that doesn't set it.
 */

export const EXPECTED_COST_UNITS = 'minor';
export const COST_UNITS_MISMATCH_EVENT = 'cost-units-mismatch';

let blocked = false;

export function isCostUnitsBlocked(): boolean {
  return blocked;
}

/** Feed the `X-Cost-Units` header value from an API response. */
export function noteServerCostUnits(header: string | null | undefined): void {
  if (!header) return; // absent → can't assert; do not block
  if (header === EXPECTED_COST_UNITS || blocked) return;
  blocked = true;
  // Log the stale-client hit for observability.
  // eslint-disable-next-line no-console
  console.warn(
    `[cost-units] server reports "${header}" but this client expects "${EXPECTED_COST_UNITS}" — stale client, blocking UI`,
  );
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(COST_UNITS_MISMATCH_EVENT, { detail: { server: header, expected: EXPECTED_COST_UNITS } }),
    );
  }
}
